import { render } from "./ratingAndComment.vue?vue&type=template&id=0f7e0682&scoped=true"
import script from "./ratingAndComment.vue?vue&type=script&lang=js"
export * from "./ratingAndComment.vue?vue&type=script&lang=js"

import "./ratingAndComment.vue?vue&type=style&index=0&id=0f7e0682&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7e0682"]])

export default __exports__